<template>
  <div>
    <div class="page-header">
      <h3 class="page-title">{{ $t('prepayments.attachments') }}</h3>
      <div class="page-actions row">
        <div class="col-xs-2 mr-4">
          <base-button
            size="large"
            icon="plus"
            color="theme"
            @click="addAttachment"
            >
            {{ $t('prepayments.newAttachment') }}
          </base-button>
        </div>
      </div>
    </div>

    <div v-cloak v-show="showEmptyScreen" class="col-xs-1 no-data-info" align="center">
      <astronaut-icon class="mt-5 mb-4"/>
      <div class="row" align="center">
        <label class="col title">{{ $t('prepayments.no_attachments') }}</label>
      </div>
      <div class="row">
        <label class="description col mt-1" align="center">{{ $t('prepayments.list_of_attachments') }}</label>
      </div>
      <div class="btn-container">
        <base-button
          :outline="true"
          color="theme"
          class="mt-3"
          size="large"
          @click="addAttachment"
        >
          {{ $t('prepayments.add_new_attactment') }}
        </base-button>
      </div>
    </div>

    <div v-show="!showEmptyScreen" class="table-container">
      <div class="table-actions mt-5">
        <p class="table-stats">{{ $t('general.showing') }}: <b>{{ prepaymentAttachments.length }}</b></p>

        <transition name="fade">
          <v-dropdown v-if="selectedPrepaymentAttachments.length" :show-arrow="false">
            <span slot="activator" href="#" class="table-actions-button dropdown-toggle">
              {{ $t('general.actions') }}
            </span>
            <v-dropdown-item>
              <div class="dropdown-item" @click="removeMultipleAttachments"  >
                <font-awesome-icon :icon="['fas', 'trash']" class="dropdown-item-icon" />
                {{ $t('general.delete') }}
              </div>
            </v-dropdown-item>
          </v-dropdown>
        </transition>
      </div>

      <div class="custom-control custom-checkbox">
        <input
          id="select-all"
          v-model="selectAllFieldStatus"
          type="checkbox"
          class="custom-control-input"
          @change="selectAllPrepaymentAttachments"
        >
        <label for="select-all" class="custom-control-label selectall">
          <span class="select-all-label">{{ $t('general.select_all') }} </span>
        </label>
      </div>

      <table-component
        ref="table"
        :show-filter="false"
        :data="prepaymentAttachments"
        table-class="table"
      >
      <table-column
          :sortable="false"
          :filterable="false"
          cell-class="no-click"
        >
          <template slot-scope="row">
            <div class="custom-control custom-checkbox">
              <input
                :id="row.id"
                v-model="selectField"
                :value="row.id"
                type="checkbox"
                class="custom-control-input"
              >
              <label :for="row.id" class="custom-control-label"/>
            </div>
          </template>
        </table-column>
       <table-column
       :label="$tc('documents.documentType', 1)"
       show="documentType.name"
       />
        <table-column
       :label="$t('documents.document')"
       show="name"
       />
        <table-column
          :sortable="false"
          :filterable="false"
          cell-class="action-dropdown"
        >
          <template slot-scope="row">
            <span> {{ $t('customers.action') }} </span>
            <v-dropdown>
                <a slot="activator" href="#"><dot-icon /></a>
                <v-dropdown-item>
                   <div class="dropdown-item">
                       <a  :href="row.path"  target="_blank" v-if="row.path">
                            <font-awesome-icon icon="eye" class="dropdown-item-icon" />
                            {{ $t('general.view') }}
                        </a>
                   </div>
                </v-dropdown-item>
                <v-dropdown-item >
                    <div class="dropdown-item" @click="deleteDocument(row)" >
                        <font-awesome-icon :icon="['fas', 'trash']" class="dropdown-item-icon" />
                        {{ $t('general.delete') }}
                    </div>
                </v-dropdown-item>
            </v-dropdown>
          </template>
        </table-column>
      </table-component>

    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import AstronautIcon from '../../components/icon/AstronautIcon'
import SingleInvoiceRow from '../invoices/SingleInvoiceRow'
export default {
    components: {
    AstronautIcon,
    SingleInvoiceRow
  },
  data () {
    return {
        advanceOption:true,
        isRequestOngoing: true,
        filtersApplied: false,
        userType:'',
        fetchData:[],
        tableDivId:"tableDivId",

      }
    },
 created(){
    this.Attachments();
  },
 computed: {
     ...mapGetters('documentType', [
      'prepaymentAttachments',
      'prepaymentTotalAttachments',
      'selectedAttachments',
      'selectedPrepaymentAttachments'
    ]),
    showEmptyScreen () {
      return !this.prepaymentTotalAttachments  && !this.isRequestOngoing
    },
     selectField: {
      get: function () {
        return this.selectedPrepaymentAttachments
      },
      set: function (val) {
        this.selectPrepaymentAttachment(val)
      }
    },
    selectAllFieldStatus: {
      get: function () {
        return this.selectAllField
      },
      set: function (val) {
        this.setSelectAllPrepaymentState(val)
      }
    },
   },
 methods: {
    ...mapActions('invoice', [
      'fetchInvoice',
      'SingleInvoiceArray'
    ]),
    ...mapActions('modal', [
      'openModal'
    ]),
    ...mapActions('documentType', [
      'deleteAttachment',
      'fetchAttachments',
      'selectAllPrepaymentAttachments',
      'setSelectAllState',
      'selectAttachment',
      'selectPrepaymentAttachment',
      'deleteMultipleAttachments',
      'fetchPrepaymentAttachments',
      'deletePrepaymentAttachment',
      'setSelectAllPrepaymentState',
      'deleteMultiplePrepaymentAttachments'
    ]),

    async addAttachment () {
      this.openModal({
        'title': 'Add Attachment',
        'componentName': 'PrePaymentAttachmentModel'
      })
    },
    async Attachments(){
        const data = {
          invoice_id: this.$route.params.id
        }
        let response = await this.fetchPrepaymentAttachments(data)
        this.isRequestOngoing = false
    },
     async deleteDocument(row){
        swal({
        title: this.$t('general.are_you_sure'),
        text: this.$tc('prepayments.confirm_attachment_delete'),
        icon: '/assets/icon/trash-solid.svg',
        buttons: true,
        dangerMode: true
      }).then(async (willDelete) => {
        if (willDelete) {
           let data={
            'attachment_id':row.id,
            'invoice_id':this.$route.params.id
            }
        let res =  await this.deletePrepaymentAttachment(data)
        if(res.data.result=='success'){
            window.toastr['success'](this.$tc('prepayments.deleteAttachment_message'))
            this.Attachments();
        }else if (res.data.error) {
            window.toastr['error'](res.data.message)
          }
        }
      })
    },
     async removeMultipleAttachments () {
      swal({
        title: this.$t('general.are_you_sure'),
        text: this.$tc('prepayments.confirm_attachment_delete', 2),
        icon: '/assets/icon/trash-solid.svg',
        buttons: true,
        dangerMode: true
      }).then(async (willDelete) => {
        if (willDelete) {
            let data={
            'attachment_ids':this.selectedPrepaymentAttachments,
            'invoice_id':this.$route.params.id
            }
          let request = await this.deleteMultiplePrepaymentAttachments(data)
          if (request.data.result=='success') {
            window.toastr['success'](this.$tc('prepayments.deleteAttachment_message', 2))
            this.Attachments();
          } else if (request.data.error) {
            window.toastr['error'](request.data.message)
          }
        }
      })
    }
 }
}
</script>
<style scoped>
#tableDivId{
  min-height: 0px;
}
</style>
